import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchPermissionModule = createAsyncThunk("fetchPermissionModule", async () => {
	const token = localStorage.getItem("auth_token");
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Access-Control-Allow-Origin": "*",
			"Content-Type": "application/json",
			Accept: "application/json",
		},
	};

	const response = await axiosHttp.get(`permission/list/admin`, config);
	
	return response.data.data;
});

const permissionListSlice = createSlice({
	name: "permissionList",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	reducers: {
		resetStatePermissionList: (state) => {
			state.isLoading = false;
			state.error = null;
			state.data = null;
		},
	},

	extraReducers: (builder) => {
		builder.addCase(fetchPermissionModule.pending, (state, action) => {
			state.isLoading = true;
		});

		builder.addCase(fetchPermissionModule.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(fetchPermissionModule.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export const { resetStatePermissionList } = permissionListSlice.actions;
export default permissionListSlice.reducer;
